import React, { FC } from 'react'
import { PATH } from '../../../../../constants/partners'
import { UIPATH } from '../../../../../constants/urls'
import WrapperImage from '../../../../global/wrapperImage'

type Props = {
  btnPrimaryIcon: any
  partnersListingNameTypes: any
}

const BecomeAPartner: FC<Props> = ({ btnPrimaryIcon, partnersListingNameTypes }) => {
  const listingNameTypes = partnersListingNameTypes ? partnersListingNameTypes[0] : {}

  return (
    <div className="PartnersLocator__filter PartnersLocator__filter--mobile">
      <h4 className="PartnersLocator__becomePartnerTitle">
        Apply to become a UiPath {listingNameTypes?.value || 'Service Partner'}
      </h4>

      <p className="PartnersLocator__becomePartnerDesc">
        Help companies along their digital transformation journey by connecting them with the UiPath
        RPA Platform
      </p>

      <a
        className="PartnersLocator__becomePartnerCTA Button Button--secondary"
        href={`${UIPATH.PROD}${PATH.BECOME_A_PARTNER}`}
        rel=" noopener">
        Become a partner
        <WrapperImage src={btnPrimaryIcon} alt="arrow" width={24} height={24} threshold={650} />
      </a>
    </div>
  )
}

export default BecomeAPartner
